<template>
    <div class="flex flex-col">
        <a
            v-if="isLoggedIn && email"
            :href="patronUrl"
            target="_blank"
            data-cy="settings-link-user"
            title="Brukerinnstillinger"
            class="menu-item flex truncate grow items-center w-fit pr-2 l2"
        >
            <i class="i-mdi-account"/>
            {{ email }}
        </a>
        <targeting-router-link
            class="l2"
            :to="ORG_SETTINGS"
            data-cy="settings-link-company"
            title="Virksomhet innstillinger"
            @click="props.close"
        >
            <i class="i-ph-buildings-fill"/>
            Virksomhetsinnstillinger
        </targeting-router-link>
    </div>
</template>

<script setup lang="ts">

import { TargetingRouterLink } from '@tritt/multipanel'
import {patronUrl} from '@/services/infrastructure/patron.service'
import {getUser, isLoggedIn} from '@/services/infrastructure/auth.service'
import {computed} from 'vue'
import {ORG_SETTINGS} from '@/org-settings'

const props = defineProps({
    close: {
        type: Function,
        required: true
    },
})

const email = computed(() => {
    if (isLoggedIn.value)
        return getUser.value?.email
    return ''
})


</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

.l1, .l2 {
    @apply my-1 flex items-center hover:text-primary;
    i {
        @apply mr-1;
    }
}

.l2 {
    @apply ml-4;
}

</style>